<ion-buttons>
  <ion-button (click)="onClose()" aria-label="Close" i18n-aria-label>
    <aaa-icon aria-hidden="true" slot="icon-only" name="close-outline" color="dark"></aaa-icon>
  </ion-button>
</ion-buttons>
